<template lang="html">
  <div class="news-list" v-if="html_show">
    <div class="time-item" v-for="i in news_list" :key="i.time">
      <div class="calendar">
        <div class="year">{{i.time | timeToYear}}</div>
        <!-- <br /> -->
        <div>{{i.time | timeToMonth}}月</div>
      </div>
      <div class="topic-item" v-for="j in i.arr" :id="j.id" :ref="j.id">
      <div>
        <p class="title" @click="open(j.id)">{{j.title | dealTitle}}<span class="open" v-if="showOpen(j.id)"><i class="iconfont">&#xe648;</i></span> </p>
        <p class="time">{{j.create_time | time_standard}}</p>
        <div class="summary" v-html="j.content" :class="{'summary-open': !showOpen(j.id)}">
          <!-- {{j.content}} -->
        </div>
        <div class="img-list" v-for="(img, index) in j.file_arr"  v-if="showOpen(j.id) ? index<1:index<j.file_arr.length" :key="img.id">
          <img :preview="j.id+img.path" :src="img.path | logo_show">
        </div>
        <!-- <SpecialComment :list="insight_theme_content" :rowid="j.module_theme_id"></SpecialComment> -->
        <div class="bottom" v-if="!showOpen(j.id)">
          <p  @click="open(j.id)">收起 <i class="iconfont">&#xe63b;</i> </p>
          <div class="right" @click="goTopicShare(j.uid)">
            <span>分享至</span>
            <div>
              <i class="iconfont">&#xe641;</i>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div v-show="is_show_more_button" class="more-button" :class="{ 'loading': button_loading }" @click="changePage">
      <span>{{button_loading ? '正在加载中...':'加载更多'}}</span>
    </div>
  </div>
  <Loading v-else="!html_show"></Loading>
</template>

<script>
import { themeNewsTopic, addPuv } from '../service'
import { is_open_mixin } from 'mobile/js/is_open_mixin'
import SpecialComment from './SpecialComment.vue'
import Loading from '@/views/Mobile/components/loading.vue'
export default {
  mixins: [is_open_mixin],
  data() {
    return {
      news_list: [],
      insight_theme_content: [],
      page: 1,

      button_loading: false,
      is_show_more_button: true,

      html_show: false,
      position: true
    }
  },
  computed: {
    req_url() {
      return this.$store.state.req_url
    }
  },
  components: {
    SpecialComment,
    Loading
  },
  methods: {
    async getList() {
      let res = await themeNewsTopic({
        "theme_id": this.$route.params.uid,
      	"page": this.page
      }, (error) => this.$Message.error('请求错误！'))
      if (res.status == 'success') {
        for(let i of res.res) {
          let temp = i.create_time.split(' ')[0].split('-')
          let index = this.news_list.findIndex((j) => j.time == temp[0]+'-'+temp[1])
          if (index != -1) {
            this.news_list[index].arr.push(i)
          } else {
            this.news_list.push({
              time: temp[0]+'-'+temp[1],
              arr: [i]
            })
          }
        }
        this.insight_theme_content = [...this.insight_theme_content,...res.insight_theme_content]
        if (res.res.length < 10) {
          this.is_show_more_button = false
        }
      } else {
        this.$Message.error(res.message)
      }
      if (!this.html_show) {
        this.html_show = true
      }
      this.$previewRefresh()
      this.$nextTick(() => {
        if (this.$store.state.topic_newest_id && this.position) { // 点击详情的轮播，然后定位
          let scrollTop = this.$refs[this.$store.state.topic_newest_id][0].getBoundingClientRect().top
          window.scrollTo( 0, scrollTop-70)
          this.position = false
          this.open_list.push(this.$store.state.topic_newest_id)
        }
      })
      this.button_loading = false
    },
    async addPuv() {
      await addPuv({ url: window.location.protocol + '//' + window.location.host+ '/mindex'  + this.$route.fullPath })
    },
    changePage() { // 翻页
      this.button_loading = true
      this.page = this.page + 1
      this.getList()
    }
  },
  created() {
    this.getList()
    this.addPuv()
  },
  destroyed() {
    this.$store.commit('updateTopicNewestId', '')
  }
}
</script>

<style lang="stylus" scoped>
.news-list
  padding: .4rem .4rem .5rem .4rem;
  .time-item
    position:relative;
    .calendar
      width: .64rem;
      height: .96rem;
      background: url(../../../../src/assets/mobile/pic/has_year.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: absolute;
      top: 0;
      left: 0;
      color: #fff;
      font-size: .24rem;
      font-weight: 600;
      text-align: center;
      // line-height: .5rem
      padding: .26rem 0 .2rem;
      div.year
        margin-bottom: .1rem;
        color: #ffc390;
    .topic-item
      margin-left: .94rem;
      .title
        font-size:.32rem;
        color: #333333;
        line-height: .48rem;
        font-weight:600;
      span.type+span.type:before
        content: ','
      span.open
        margin-left: .1rem;
        color: #ff8824;
        font-weight:normal;
        i
          font-size: .24rem !important;
      .time
        margin: .1rem 0 .15rem 0;
        font-size: .24rem;
        color: #999;
      .img-list
        width: 100%;
        // height: 3.35rem;
        text-align: center;
        img
          max-width: 100%;
          max-height: 3.35rem;
          margin: 0 auto;
          display: block;
      .summary
        background: #F9F9F9;
        font-size: .28rem;
        color: #666666;
        line-height: .44rem;
        padding: 0;
        height: 0;
        overflow: hidden;
        margin-bottom: .15rem;
        &.summary-open
          padding: .3rem;
          height: auto;
      .bottom
        margin-top: .34rem;
        display: flex;
        justify-content: space-between;
        p
          color: #ff8824;
          font-size: .28rem;
          i
            font-size: .24rem;
            margin-left: .16rem;
        .right
          display: flex;
          span
            font-size: .24rem;
            color: #999999;
            margin-top: 0.02rem;
          div
            width: .68rem;
            height: .68rem;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            border: 1px #eee solid;
            margin-top: -.17rem;
            margin-left: .2rem;
            i
              color: rgb(46, 198, 107);
              font-size: .40rem;
    .topic-item+.topic-item
      margin-top: .4rem;
      padding-top: .4rem;
      border-top: 1px solid #E9E9E9;
  .time-item+.time-item
    margin-top: .3rem
  .more-button
    margin-top: .3rem;
    background: #FFFAF6;
    border-radius: .08rem;
    text-align: center;
    color: #ff8824;
    font-size: .3rem;
    padding: .24rem 0
</style>
